<div class="wrapper wrapper-medium">
  <div class="page-header">
    <h1>Households</h1>
    <p class="page-subtitle">The list below shows all households and their members.</p>
  </div>

  <div class="toolbar" data-testid="households-controls-row">
    <div class="households-search-group" role="search">
      <svg class="households-search-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input
        type="search"
        class="households-search-input"
        placeholder="Search households"
        aria-label="Search households by name"
        data-testid="input-search-households"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange($event)"
        (keyup.enter)="onSearch()"
      />
      <button
        *ngIf="searchQuery"
        type="button"
        class="households-search-clear"
        aria-label="Clear search input"
        data-testid="btn-clear-households-search"
        (click)="clearSearch()"
      >
        &times;
      </button>
    </div>

    <button
      data-testid="btn-create-household"
      type="button"
      class="btn btn-primary btn-small tool-btn create-household-btn"
      (click)="openNewHouseholdModal()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
      <span>Create Household</span>
    </button>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-indicator">
    <loading message="retrieving households..."></loading>
  </div>

  <!-- Households list -->
  <div *ngIf="!isLoading && households.length > 0" class="list-container">
    <!-- Household item -->
    <div *ngFor="let household of households" class="expandable-item" [class.expanded]="expandedHouseholdId === household.HOUSEHOLD_ID">
      <!-- Household header -->
      <div class="expandable-header" (click)="toggleHousehold(household.HOUSEHOLD_ID)">
        <div class="item-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </div>
        <div class="item-details">
          <span data-testid="household-name" class="item-name">{{ household.HOUSEHOLD_NAME }}</span>
          <span data-testid="household-id" class="item-subtitle">ID: {{ household.HOUSEHOLD_ID }}</span>
        </div>
        <div class="expand-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            [class.rotated]="expandedHouseholdId === household.HOUSEHOLD_ID"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </div>

      <!-- Users container (expanded view) -->
      <div class="expandable-content" *ngIf="expandedHouseholdId === household.HOUSEHOLD_ID">
        <!-- Users header with Add User button -->
        <div class="content-header" *ngIf="!loadingUsers">
          <h4 class="content-title">Members</h4>
          <a class="text-btn" data-testid="btn-see-detail" [routerLink]="['/households', household.HOUSEHOLD_ID]">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M22 3H2c-1.09.04-1.96.91-2 2v14c.04 1.09.91 1.96 2 2h20c1.09-.04 1.96-.91 2-2V5a2.074 2.074 0 0 0-2-2m0 16H2V5h20v14m-8-2v-1.25c0-1.66-3.34-2.5-5-2.5c-1.66 0-5 .84-5 2.5V17h10M9 7a2.5 2.5 0 0 0-2.5 2.5A2.5 2.5 0 0 0 9 12a2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 9 7m5 0v1h6V7h-6m0 2v1h6V9h-6m0 2v1h4v-1h-4"/></svg>
            <span>See Detail</span>
          </a>
          <button class="text-btn" data-testid="btn-add-user" (click)="$event.stopPropagation(); openNewUserModal(household.HOUSEHOLD_ID)">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            <span>Add User</span>
          </button>
        </div>
        
        <!-- Loading users -->
        <div *ngIf="loadingUsers" class="content-loading">
          <loading message="loading users..."></loading>
        </div>

        <!-- No users message -->
        <div *ngIf="!loadingUsers && (!householdUsers[household.HOUSEHOLD_ID] || householdUsers[household.HOUSEHOLD_ID].length === 0)" class="content-empty">
          <p>No users found in this household</p>
        </div>

        <!-- Users list -->
        <div *ngIf="!loadingUsers && householdUsers[household.HOUSEHOLD_ID] && householdUsers[household.HOUSEHOLD_ID].length > 0" class="users-list">
          <div *ngFor="let user of householdUsers[household.HOUSEHOLD_ID]" class="list-item" (click)="$event.stopPropagation(); navigateToUserDetail(user)">
            <div class="item-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div class="item-details">
              <span class="item-name" data-testid="household-user-name">{{ user.FIRST_NAME }} {{ user.LAST_NAME }}</span>
              <span class="item-subtitle" data-testid="household-user-email">{{ user.EMAIL }}</span>
            </div>
          </div>
        </div>

        <!-- Managers section (for admins) -->
        <div *ngIf="isSupervisor" class="managers-section">
          <div class="content-header">
            <h4 class="content-title">Managers</h4>
            <div class="assign-manager-container">
              <button *ngIf="!showManagerSearch" data-testid="household-button-add-manager" class="text-btn" (click)="$event.stopPropagation(); toggleManagerSearch(household.HOUSEHOLD_ID)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
                <span>Add Manager</span>
              </button>

              <div *ngIf="showManagerSearch" class="assign-manager-form">
                <div class="form-group search search-wrapper">
                  <input
                    type="text"
                    placeholder="Type a name to search..."
                    data-testid="household-search-managers"
                    [(ngModel)]="managerSearchQuery"
                    (ngModelChange)="onManagerSearch($event)"
                    (focus)="onManagerSearchFocus()"
                    (blur)="onManagerSearchBlur()"
                    (click)="$event.stopPropagation()"
                  />
                  <div *ngIf="isManagerSearchFocused && (allManagers.length > 0 || noManagerResults || isSearchingManagers)" class="search-results">
                    <div *ngIf="isSearchingManagers" class="search-result-item searching">
                      <loading message="Searching..."></loading>
                    </div>
                    <div *ngFor="let manager of allManagers" class="search-result-item" (click)="$event.stopPropagation(); selectManager(manager)">
                      {{ manager.FIRST_NAME }} {{ manager.LAST_NAME }}
                    </div>
                    <div *ngIf="noManagerResults" class="search-result-item no-results">
                      No results found
                    </div>
                    <div *ngIf="allManagers.length > 0" class="search-results-footer">
                      Showing {{ allManagers.length }} results for "{{ managerSearchQuery }}"
                    </div>
                  </div>
                </div>
                <div class="button-group" style="display: flex; align-items: center; gap: 10px;">
                  <div (click)="$event.stopPropagation(); assignManager(household.HOUSEHOLD_ID)">
                    <saffron-button
                      text="Assign"
                      data-testid="btn-assign-manager"
                      type="primary"
                      size="small"
                      [width]="'80px'"
                      [height]="'28px'"
                      [is_loading]="isAssigningManager"
                      [is_disabled]="!selectedManagerId || isAssigningManager"
                    ></saffron-button>
                  </div>
                  <button class="btn btn-secondary btn-small" data-testid="household-button-cancel-manager" (click)="$event.stopPropagation(); toggleManagerSearch(household.HOUSEHOLD_ID)">Cancel</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading managers -->
          <div *ngIf="loadingManagers" class="content-loading">
            <loading message="loading managers..."></loading>
          </div>

          <!-- No managers message -->
          <div *ngIf="!loadingManagers && (!householdManagers[household.HOUSEHOLD_ID] || householdManagers[household.HOUSEHOLD_ID].length === 0)" class="content-empty">
            <p>No managers assigned to this household</p>
          </div>

          <!-- Managers list -->
          <div *ngIf="!loadingManagers && householdManagers[household.HOUSEHOLD_ID] && householdManagers[household.HOUSEHOLD_ID].length > 0" class="users-list">
            <div *ngFor="let manager of householdManagers[household.HOUSEHOLD_ID]" class="list-item" (click)="$event.stopPropagation(); navigateToManagerDetail(manager)">
              <div class="item-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 2048 2048"><path fill="currentColor" d="M1792 641q0 23 12 52t29 60t37 57t34 44q72 86 108 178t36 206q0 108-46 200t-123 167q-38 37-85 71t-98 62t-105 50t-106 35q-114 28-219 64t-211 89q-16 8-31 8t-31-8q-105-53-210-89t-220-64q-52-13-105-34t-105-50t-99-63t-85-71q-76-74-122-166T0 1238q0-114 36-205t108-179q14-17 33-44t37-57t30-59t12-53q0-66-27-113t-75-90q-13-11-19-23t-6-30q0-25 18-43L402 83q9-9 21-14t25-5q15 0 25 5t21 15q42 38 87 56t103 18q37 0 78-8t79-25t72-40t57-55q11-14 23-22t31-8q18 0 30 8t24 22q22 31 56 54t72 40t80 25t78 9q57 0 102-18t88-56q11-10 21-15t24-5q28 0 47 19l255 259q18 18 18 43q0 17-6 29t-19 24q-48 42-75 89t-27 114zm-768 1207q81-42 165-72t172-54q24-7 48-12t48-12q52-14 106-37t106-55t97-71t80-87t54-101t20-114q0-73-15-123t-41-91t-59-82t-67-95q-14-21-27-45t-23-51t-17-52t-7-53q0-72 25-138t74-119l-167-169q-51 36-110 53t-122 18q-41 0-88-9t-92-25t-88-39t-72-51q-31 28-72 51t-88 39t-92 25t-88 9q-62 0-121-17t-111-54L285 384q48 53 73 119t26 138q0 26-6 52t-17 53t-24 50t-27 46q-34 54-67 94t-58 82t-41 92t-16 123q0 60 20 114t54 101t80 86t97 71t105 55t107 38q24 7 48 12t48 12q87 23 171 53t166 73z"/></svg>
              </div>
              <div class="item-details">
                <span class="item-name">{{ manager.FIRST_NAME }} {{ manager.LAST_NAME }}</span>
                <span class="item-subtitle">{{ manager.EMAIL }}</span>
              </div>
              <button class="btn btn-secondary btn-small" data-testid="household-button-unassign-manager" (click)="$event.stopPropagation(); unassignManager(manager.USER_ID, household.HOUSEHOLD_ID)">Unassign</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="pagination-footer">
      <p>Showing {{ households.length }} {{ searchIsActive ? 'of ' + householdsCache.length + ' ' : '' }}households</p>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && households.length === 0" class="empty-state">
    <div class="empty-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </div>
    <p class="empty-message">No households found</p>
    <p *ngIf="searchIsActive" class="empty-hint">Try adjusting your search criteria</p>
  </div>
</div>

<!-- Modal Overlay -->
<div class="modal-overlay" [class.active]="isNewHouseholdModalOpen || isNewUserModalOpen" 
     (click)="isNewHouseholdModalOpen ? closeNewHouseholdModal() : closeNewUserModal()"></div>

<!-- New Household Modal -->
<app-new-household 
  *ngIf="isNewHouseholdModalOpen"
  [isOpen]="isNewHouseholdModalOpen"
  (close)="closeNewHouseholdModal()"
  (householdCreated)="onHouseholdCreated()">
</app-new-household>

<!-- New User Modal -->
<app-new-user
  *ngIf="isNewUserModalOpen && selectedHouseholdId"
  [isOpen]="isNewUserModalOpen"
  [householdId]="selectedHouseholdId"
  (close)="closeNewUserModal()"
  (userCreated)="onUserCreated()">
</app-new-user>
